// 资源基址（图片、虚拟礼物下载链接等都以它为前缀拼接）。
//
// 取值优先级：
//   1) 构建时注入的 VUE_APP_ASSET_BASE（在 admin/.env.production 里配置，见 admin/.env.example）
//   2) 旧的后端直连地址兜底，但**跟随页面协议**：页面是 HTTPS 时用 https，
//      避免浏览器按「混合内容」拦截 http 资源导致全站图片打不开
//
// 想改成相对路径（推荐做法：nginx 把 /avataruploads/ 代理到后端 public 目录）时，
// 在 .env.production 里配置 VUE_APP_ASSET_BASE=/  即可（末尾斜杠由 resolveImageUrl 处理）。
export const ASSET_BASE = (() => {
    const configured = (process.env.VUE_APP_ASSET_BASE || '').trim();
    if (configured) return configured.replace(/\/+$/, '');

    const fallbackHost = '101.35.160.213:3001';
    try {
        if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') {
            return 'https://' + fallbackHost;
        }
    } catch (e) {
        // 极端环境下拿不到 window，用默认值即可
    }
    return 'http://' + fallbackHost;
})();
